import { render } from "./Designation.vue?vue&type=template&id=ddb7b08c&scoped=true"
import script from "./Designation.vue?vue&type=script&lang=js"
export * from "./Designation.vue?vue&type=script&lang=js"

import "./Designation.vue?vue&type=style&index=0&id=ddb7b08c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb7b08c"]])

export default __exports__